<div class="flex flex-col gap-5">
    <bb-field label="Screening brief name" [required]="true"
        hint="Title Case works best. You'll spot this in your dashboard later.">
        <input [value]="createScreeningService.basicInfoModel().briefTitle" (input)="setTitle($any($event.target).value)"
            data-guide-id="screening.briefTitle"
            placeholder="e.g. Spring Ambassador Vetting — UK"
            class="w-full rounded-md border border-border bg-card px-3.5 py-2.5 text-base outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25 placeholder:text-muted-foreground" />
    </bb-field>

</div>  